import { createContext } from "react";

import { ITableCsvExport } from "./tableCsv";

/**
 * How a table's CSV export reaches the header icon (beside Refresh) from the
 * `TablePagination` footer that has always carried the configuration.
 *
 * `TableContainer` provides it; `TablePagination` publishes the page's
 * `exportCsv` prop into it (and renders no footer button); `TableWrapper`
 * reads it and shows the download icon in the table header. Pages pass
 * exactly what they always did. Outside a provider (a pagination footer
 * rendered on its own) the value is null and the footer keeps its old button.
 */
export interface ITableExportContextValue {
  config: ITableCsvExport<unknown> | null;
  publish: (config: ITableCsvExport<unknown> | null) => void;
}

export const TableExportContext =
  createContext<ITableExportContextValue | null>(null);
